import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { atom } from 'jotai';
import { IArticleRelatedPost } from 'shared/atoms/article';

export const $DiscoverArticleRelatedPost = safeAtomFamily((groupId: string) => {
  const a = atom<IArticleRelatedPost>({
    searchId: '',
    items: [],
    cursor: 0,
    hasMore: true,
  });
  a.debugLabel = `$DiscoverArticleRelatedPost+${encodeURIComponent(groupId)}`;

  return a;
});
